@if (logoUrl) {
  <header
    class="fixed w-full z-50 px-4 py-2 shadow-md flex items-center gap-6 bg-primary-50 h-14">
    @if (logoLink) {
      <a [href]="logoLink" target="_blank" rel="noopener noreferrer">
        <img [src]="logoUrl" class="h-10 w-auto" alt="logo" />
      </a>
    } @else {
      <img [src]="logoUrl" class="h-10 w-auto" alt="logo" />
    }
    <!-- <nav class="flex justify-between items-center">
      <ul class="text-secondary-600 font-medium text-xs flex gap-4">
        <li>
          <a
          href="https://hf964hq0-5200.brs.devtunnels.ms/results?USD/OPEN_JAW/BUE-MAD,MAD-BCN,BCN-LON,LON-EZE/10-01-2026,17-01-2026,24-01-2026,31-01-2026/1,0,0/Y/beee505db91f4e04"
          rel="noopener noreferrer">
          M
        </a>
      </li>
      <li>
        <a
        href="https://hf964hq0-5200.brs.devtunnels.ms/results?USD/ROUND_TRIP/BUE-UAQ/12-01-2026,16-01-2026/2,1,0/Y/060467b0458746d6"
        rel="noopener noreferrer">
        IyV
      </a>
    </li>
    <li>
      <a
      href="https://w7c7ccp9-5200.brs.devtunnels.ms/results?USD/OPEN_JAW/BUE-MAD,MAD-BCN,BCN-LON,LON-EZE/10-01-2026,17-01-2026,24-01-2026,31-01-2026/1,0,0/Y/beee505db91f4e04"
      rel="noopener noreferrer">
      M
    </a>
  </li>
  <li>
    <a
    href="https://w7c7ccp9-5200.brs.devtunnels.ms/results?USD/ROUND_TRIP/BUE-UAQ/12-01-2026,16-01-2026/2,1,0/Y/060467b0458746d6"
    rel="noopener noreferrer">
    IyV
  </a>
</li>
</ul>
</nav> -->
  </header>
}
